import React from "react";
import { useSelector } from "react-redux";
import Form from "../components/Form";
import Navbar from "../components/Navbar";
import ProductCard from "../components/ProductCard";

const Home = () => {
  const { products } = useSelector((state) => state.products);

  return (
    <div>
      <Navbar />
      <main className="py-16">
        <div className="productWrapper">
          <div className="productContainer" id="lws-productContainer">
            {products?.length >= 1 ? (
              products?.map((item) => (
                <ProductCard key={item?.id} item={item} />
              ))
            ) : (
              <div>No Product Found. But You Can Add</div>
            )}
          </div>
          <div>
            <div className="formContainer">
              <h4 className="formTitle">Add New Product</h4>
              <Form />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Home;
